import cloneDeep from 'lodash/cloneDeep'
import { AccountTypes } from '@/constants/user/accountTypes'
import { VacancyApplicationStatuses } from '@/constants/vacancies/vacancyApplicationStatuses'
import File from '@/models-ts/File'
import Avatar from '@/models-ts/user/Avatar'
import VacancyApplicationMeta from '@/models-ts/vacancies/VacancyApplicationMeta'

type ApplicationUser = {
  id: number
  name: string
  type: AccountTypes
  avatar: Avatar
  reviewsCount: number
  avgReviews: string
}

export default class VacancyApplicationItem {
  id: number
  isRead: boolean
  freelancer: ApplicationUser
  status: VacancyApplicationStatuses
  comment: string
  cvFile?: File
  vacancyId: number
  meta?: VacancyApplicationMeta | null

  constructor(data: Partial<VacancyApplicationItem>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.VacancyApplication) {
    const freelancer = data.relations.Freelancer
    const files = data.relations.File || []
    let cvFile
    if (files.length) {
      cvFile = File.fromServer(files[0])
    }
    return new VacancyApplicationItem({
      id: data.id,
      isRead: Boolean(data.is_read),
      status: data.status,
      comment: data.comment,
      cvFile,
      vacancyId: data.vacancy_id,
      freelancer: {
        id: freelancer.id,
        name: freelancer.name,
        avatar: Avatar.fromServer(freelancer.avatar),
        type: freelancer.type,
        avgReviews: (freelancer.profile.avg_reviews || 0).toFixed(2),
        reviewsCount: freelancer.reviews_count,
      },
      meta: data?.tabs_meta || null,
    })
  }

  get isActive() {
    return [VacancyApplicationStatuses.NEW, VacancyApplicationStatuses.IN_PROGRESS].includes(this.status)
  }
}
